import { IFeedbackPayload } from '@/interfaces/powerMarkets/payloads/IFeedbackPayload.ts';
import { ApiPromise, useApi } from '@/api/useApi.ts';

const staticApi = useApi('static');

function postFeedback (payload: IFeedbackPayload): ApiPromise<void> {
    return staticApi.post<IFeedbackPayload, void>({
        endpoint: '/feedback',
        payload,
    });
}

export const feedbackApi = {
    postFeedback,
};
